import { Expose, Transform, Type } from 'class-transformer';

import { CallType } from '../../common';
import { Model } from './model';
import { Session } from './session-model';
import { StudentModel } from './student-model';
import { TeacherModel } from './teacher-model';

export class CallModel extends Model {
  @Expose() callId: string;
  @Expose() duration: string;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  endDateTime: Date | null;
  @Expose() errorCount: number;
  @Expose() isNewStudent: boolean;
  @Expose() recordUrl: string;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  startDateTime: Date | null;
  @Expose() status: string;
  @Expose() studentRate: number;
  @Expose() studentReviewId: string;
  @Expose() type: CallType;
  @Expose()
  @Type(() => StudentModel)
  student: StudentModel;
  @Expose() 
  @Type(() => TeacherModel)
  teacher: TeacherModel;
  @Expose()
  @Transform(({ obj }) => {
    return getTeacherRate(obj);
  })
  rate: number;

  @Expose()
  @Type(() => Session)
  session: Session;
  @Expose() reviewerName: string;
  @Expose() isRecordUrl: boolean
}

function getTeacherRate(obj: CallModel): number {
  let rate = 0;
  if (obj && obj.session && obj.session?.records) {
    obj.session?.records.forEach((record) => {
      rate += record.rate;
    });
  }
  return rate;
}
